export const canCancelDemand = (demand, permitted) => Boolean(
  permitted
  && ['issued', 'overdue'].includes(demand?.status)
  && Number(demand?.paid_amount || 0) === 0
);

export const demandRevisionLabel = demand => `Revision ${Number(demand?.revision_number || 1)}`;

export const demandCancellationPayload = (demand, reason) => ({
  version: Number(demand?.version),
  reason: String(reason || '').trim(),
});
